import { useCallback, useRef } from "react";
import {
  ACTIVITIES_SECONDARY_SEARCH_FOCUSED,
  ACTIVITIES_SECONDARY_SEARCH_TYPED,
  ACTIVITIES_SECONDARY_SEARCH_RESULT_CLICKED,
  ActivitiesSecondarySearchResultType,
  ActivitiesSecondarySearchResultClickedProperties,
} from "redmond";
import { trackEvent } from "../api/v0/analytics/trackEvent";

const getResultType = (
  categoryLabel: string
): ActivitiesSecondarySearchResultType => {
  if (categoryLabel.toLowerCase().includes("categor")) {
    return ActivitiesSecondarySearchResultType.Category;
  }
  if (categoryLabel.toLowerCase().includes("attraction")) {
    return ActivitiesSecondarySearchResultType.Attraction;
  }
  return ActivitiesSecondarySearchResultType.Activity;
};

export const useSecondarySearchAnalytics = () => {
  const hasFiredFocusEventRef = useRef(false);
  const hasFiredTypedEventRef = useRef(false);

  const resetAnalyticsRefs = useCallback(() => {
    hasFiredFocusEventRef.current = false;
    hasFiredTypedEventRef.current = false;
  }, []);

  const trackSecondarySearchFocus = useCallback(() => {
    if (!hasFiredFocusEventRef.current) {
      hasFiredFocusEventRef.current = true;
      trackEvent({
        eventName: ACTIVITIES_SECONDARY_SEARCH_FOCUSED,
        properties: {},
      }).catch(() => {});
    }
  }, []);

  const trackSecondarySearchTyped = useCallback(() => {
    if (!hasFiredTypedEventRef.current) {
      hasFiredTypedEventRef.current = true;
      trackEvent({
        eventName: ACTIVITIES_SECONDARY_SEARCH_TYPED,
        properties: {},
      }).catch(() => {});
    }
  }, []);

  const trackSecondarySearchResultClicked = useCallback(
    (categoryLabel: string, resultIndex: number) => {
      const properties: ActivitiesSecondarySearchResultClickedProperties = {
        result_type: getResultType(categoryLabel),
        result_index: resultIndex,
      };
      trackEvent({
        eventName: ACTIVITIES_SECONDARY_SEARCH_RESULT_CLICKED,
        properties,
      }).catch(() => {});
    },
    []
  );

  return {
    resetAnalyticsRefs,
    trackSecondarySearchFocus,
    trackSecondarySearchTyped,
    trackSecondarySearchResultClicked,
  };
};
